/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { Wrapper } from '.'
 */

/**
 * @param {{sequence?: number | undefined}} a
 * @param {{sequence?: number | undefined}} b
 * @returns {number}
 */
export function sortBySequence(a, b) {
  if (a.sequence === undefined && b.sequence === undefined) {
    return 0;
  }
  if (a.sequence === undefined) {
    return 1;
  }
  if (b.sequence === undefined) {
    return -1;
  }
  return a.sequence - b.sequence;
}

/**
 * @param {Wrapper} wrapper
 * @returns {string}
 */
export function getWrapperNextUrl(wrapper) {
  return replaceAllMacro(wrapper.VASTAdTagURI);
}

/**
 * @param {string} str
 * @returns {string}
 */
export function replaceAllMacro(str) {
  return replaceTimestampMacro(replaceCacheBustingMacro(str));
}

/**
 * @param {string} str
 * @param {(() => Date) | undefined} now
 * @returns {string}
 */
export function replaceTimestampMacro(str, now = () => new Date()) {
  const timestamp = now ? now().toString() : Date.now().toString();
  return replaceMacro(str, '[TIMESTAMP]', timestamp);
}

/**
 * @param {string} str
 * @param {(() => number) | undefined} randomNumber
 * @returns {string}
 */
export function replaceCacheBustingMacro(
  str,
  randomNumber = () => Math.floor(10000000 + Math.random() * 90000000)
) {
  return replaceMacro(str, '[CACHEBUSTING]', randomNumber().toString());
}

/**
 * @param {string} str
 * @param {string} errorCode
 * @returns {string}
 */
export function replaceErrorCodeMacro(str, errorCode) {
  return replaceMacro(str, '[ERRORCODE]', errorCode);
}

/**
 * @param {string} str
 * @param {string} macro
 * @param {string} value
 * @returns {string}
 */
function replaceMacro(str, macro, value) {
  return str
    .replaceAll(macro, value)
    .replaceAll(encodeURIComponent(macro), value);
}
